export {
  affiliateResponseSchema,
  affiliateSchema,
  type Affiliate,
  type AffiliateResponse,
} from './Affiliate';

export {
  availablePrizeSchema,
  cartRaffleSchema,
  customerBalanceResponseSchema,
  customerContactSchema,
  customerDocumentSchema,
  customerUserInfoSchema,
  customerWinnersFeedResponseSchema,
  customerWinnersFeedSchema,
  purchasedRaffleModelSchema,
  purchasedRaffleResponseSchema,
  ticketPrizeSchema,
  ticketsByRaffleResponseSchema,
  ticketSchema,
  type CustomerBalanceResponse,
  type CustomerGuest,
  type CustomerGuestDocument,
  type CustomerWinnersFeedResponse,
  type PurchasedRaffleResponse,
  type Ticket,
  type TicketsByRaffleResponse,
} from './Customer';

export { customerBalanceSchema, type CustomerBalance } from './CustomerBalance';
export { customerInfoSchema, type CustomerInfo } from './CustomerInfo';
export {
  exatoHashRequestSchema,
  exatoHashResponseSchema,
  type ExatoHashRequest,
  type ExatoHashResponse,
} from './ExatoValidation';
export { faqSchema, type Faq } from './Faq';
export { personalDataSchema, type PersonalData } from './PersonalData';

export {
  purchaseRequestSchema,
  purchaseResponseSchema,
  type PurchaseRequest,
  type PurchaseResponse,
} from './Purchase';

export { purchasedRaffleSchema, type PurchasedRaffle } from './PurchasedRaffle';
export { raffleSchema, type Raffle } from './Raffle';

export {
  raffleDetailSchema,
  type CartRaffle,
  type RaffleDetail,
  type RaffleDetailParams,
} from './RaffleDetail';

export {
  withdrawTransactionSchema,
  type WithdrawTransaction,
} from './WithdrawTransaction';

export { walletHistorySchema, type WalletHistory } from './WalletHistory';

export {
  prizeSchema,
  ticketByRaffleSchema,
  userSchema,
  type Prize,
  type TicketByRaffle,
  type TicketsByRaffleParams,
  type User,
} from './TicketsByRaffle';

export {
  prizeScratchedSchema,
  setScratchedRequestSchema,
  setScratchedResponseSchema,
  ticketToScratchSchema,
  type PrizeScratched,
  type SetScratchedParams,
  type SetScratchedRequest,
  type SetScratchedResponse,
  type TicketToScratch,
} from './SetScratched';

export {
  availablePrizesSchema,
  rafflePurchasedSchema,
  rafflesPurchasedResponseSchema,
  type RafflePurchased,
  type RafflesPurchasedResponse,
} from './Raffles';

export { systemParametersSchema, type SystemParameters } from './SystemParameters';
export { ticketByCartRaffleSchema, type TicketByCartRaffle } from './TicketsByCartRaffle';

export { userLoginSchema, type UserLoginFormData } from './UserLogin';

export { type LuckyTicketsByRaffle } from './LuckyTicketsByRaffle';

export { type HighlightedRaffleDetails } from './HighlightedRaffleDetails';

export {
  ticketDetailsSchema,
  type TicketDetails,
  type TicketDetailsParams,
} from './TicketDetails';

export { addressSchema, type Address } from './Address';
export { walletWithdrawRequest, type WalletWithdrawRequest } from './WalletWithdraw';

export { editProfileSchema, type EditProfileFormData } from './EditProfile';

export {
  winnerVideoSchema,
  winnerVideosResponseSchema,
  type WinnerVideo,
  type WinnerVideosResponse,
} from './WinnerVideo';

export {
  type WhitelabelConfigValue,
  type WhitelabelConfigResponse,
} from './WhitelabelConfig';

export {
  customerProfileFormSchema,
  type CustomerProfile,
  type CustomerProfileAddress,
  type CustomerProfileFormInput,
  type CustomerProfileFormData,
} from './CustomerProfile';
export { recoveryPhoneSchema, type RecoveryPhoneFormData } from './RecoveryPhone';
export {
  OTP_HEADER_CURRENT_PHONE,
  OTP_HEADER_NEW_PHONE,
  isOtpChallengeHeader,
  parseOtpChallenge,
  type OtpChallenge,
  type OtpChallengeHeader,
  type OtpChallengeTarget,
  type OtpHeaders,
} from './OtpChallenge';

export {
  CpfRegistrationStatus,
  customerGuestStatusSchema,
  type CustomerGuestStatus,
} from './CpfRegistrationStatus';

export {
  addFullnameValidationIssue,
  addSocialNameValidationIssues,
  customerRegistrationBaseSchema,
  documentFormSchema,
  phoneFormSchema,
  registrationFormSchema,
  type DocumentFormData,
  type PhoneFormData,
  type RegistrationFormData,
} from './CustomerRegistrationForm';
